<template>
  <SearchWrapper :record-type="RecordType.Lesson">
    <template #filters>
      <LessonFilters />
    </template>

    <AisStateResults>
      <template #default="{ results: { hits, query } }">
        <AisHits v-if="hits.length > 0">
          <template #default="{ items }">
            <div class="columns-1 lg:columns-2 gap-x-8">
              <template
                v-for="item in items"
                :key="item.uuid"
              >
                <div class="mb-8 break-inside-avoid">
                  <LessonCard :lesson="item" />
                </div>
              </template>
            </div>
          </template>
        </AisHits>
        <div
          v-else
          class="py-8 text-center text-gray-800"
        >
          No results have been found
          <template v-if="query">
            for <strong><q>{{ query }}</q></strong>
          </template>
        </div>
        <SearchPagination />
      </template>
    </AisStateResults>
  </SearchWrapper>
</template>

<script lang="ts">
export default { name: 'LessonSearch' }
</script>

<script setup lang="ts">
import { AisHits, AisStateResults } from 'vue-instantsearch/vue3/es'

import { RecordType } from '~/types/records/RecordType'

import SearchPagination from '~/components/externalContent/search/SearchPagination.vue'
import SearchWrapper from '~/components/externalContent/search/SearchWrapper.vue'
import LessonCard from './LessonCard.vue'
import LessonFilters from './LessonFilters.vue'
</script>
